import React from "react";
import BrandWordmark from "./BrandWordmark";

/**
 * BrandLogo — back-compat wrapper kept for callsites that import BrandLogo.
 * The new authoritative implementation is `BrandWordmark` — an inline SVG that
 * shifts blue↔white between day & night themes automatically.
 *
 * Props mapped to BrandWordmark:
 *   size    → wordmark icon height in px (default 36)
 *   to      → router target (null = render plain inline span)
 *   testId  → data-testid root
 *   className → extra wrapper classes
 *
 * The legacy `variant="dark"` prop is now a no-op because the wordmark is
 * already theme-aware — no more white pill wrapper needed.
 */
export default function BrandLogo({
  size = 36,
  to = "/",
  withTagline = false,
  className = "",
  testId = "brand-logo",
  // kept for compatibility; ignored
  variant: _variant,
}) {
  return (
    <BrandWordmark
      size={size}
      to={to}
      tagline={withTagline}
      testId={testId}
      className={className}
    />
  );
}
